import gsap from "gsap";
import { horizontalLoop } from "./utils";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const marquees = document.querySelectorAll(".marquee");
marquees.forEach((marquee) => {
  const marqueeItems = marquee.querySelectorAll(".rail ");
  horizontalLoop(marqueeItems, {
    duration: 1,
    ease: "power2.inOut",
    repeat: -1,
  });
});
